require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ../~/angular-sanitize/index.js
// module id = 207
// module chunks = 2